export default "__VITE_ASSET__awdDX05___"